module.exports = __webpack_public_path__ + "assets/financial.88e47f39.svg";